import React, { useContext } from "react";
import { Box, Card, Grid } from "@mui/material";
import { Formik } from "formik";
import { TaxiBookingContext } from "./BookTaxiContext";
import { BrandContext } from "../../../contexts/BrandContext";
import { getValidationFromFields, initialValues } from "../form/FormUtilities";
import BasicInputField from "../form/BasicInputField";


export default function ExtraDetails(props){

    const {
        bookingHook=''
    } = props;


    const taxiBookingContext = useContext(TaxiBookingContext);
    const brandContext = useContext(BrandContext);
    const bookingDataObject = taxiBookingContext.bookingData[bookingHook];
    const {
        bookingData=null,
    } = taxiBookingContext;

    const formFields = {
        'shareTaxi': {
            'label': 'shareTaxiLabel',
            'type': 'checkbox',
            'default':'1'
        },
        'description': {
            'label': 'otherTaxiNotes',
            'type': 'textarea',
            required:false
        },
    }

    return (
        <Box>
            <Card
                    variant="outlined" 
                    className="lightBox sectionBox"
                >
                    <Formik
                        initialValues={initialValues(formFields)}
                        validationSchema={getValidationFromFields(formFields)}
                        onSubmit={(values)=>{
                            
                        }}
                    >
                        {formikProps => (
                            <Box>
                                <form onSubmit={formikProps.handleSubmit}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={12}>
                                            <BasicInputField
                                                sx={{width:'100%'}}  
                                                formik={formikProps}
                                                formFields={formFields} 
                                                fieldName="shareTaxi"
                                                className="boldLabel"
                                                onChange={(e) => {
                                                    const val = e.target.checked;
                                                    bookingData.shareTaxi = val;
                                                    taxiBookingContext.setState({});
                                                }}
                                            />    
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <BasicInputField
                                                sx={{width:'100%'}}  
                                                formik={formikProps}
                                                formFields={formFields} 
                                                fieldName="description"
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    bookingData.description = val;
                                                    taxiBookingContext.setState({});
                                                }}
                                            />    
                                        </Grid>
                                    </Grid>
                                </form>        
                            </Box>
                        )}
                </Formik>
            </Card>
        </Box>
    );

}